import React from 'react';
import { PictoProps } from './index';

export const OuSejourner = (props: PictoProps) => (
  <svg
    width={props.width || '25'}
    height={props.height || '23'}
    viewBox="0 0 25 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.5673 13.8713C24.5673 13.7688 24.5332 13.6319 24.4989 13.5294L21.8334 7.2075V0.885565C21.8334 0.407161 21.4575 0.03125 20.9791 0.03125H3.61944C3.14104 0.03125 2.76513 0.407161 2.76513 0.885565V7.2075L0.0996629 13.5294C0.0655763 13.6319 0.03125 13.7344 0.03125 13.8713V22.141H1.73988V18.7922H22.8244V22.141H24.533V18.2451H24.4989C24.533 18.1767 24.533 18.0742 24.533 17.9717V13.871L24.5673 13.8713ZM4.06375 8.57444H6.2508V9.53127C6.2508 10.0097 6.62671 10.3856 7.10512 10.3856H17.5619C18.0403 10.3856 18.4162 10.0097 18.4162 9.53127V8.57444H20.5692L22.4487 13.0169H2.18438L4.06375 8.57444ZM16.6734 5.39651V8.71125H13.1537V5.39651H16.6734ZM11.445 8.71125H7.92526V5.39651H11.445V8.71125ZM4.47382 1.74004H20.0907V6.86593H18.348V4.54231C18.348 4.06391 17.9721 3.688 17.4937 3.688H7.071C6.5926 3.688 6.21669 4.06391 6.21669 4.54231V6.86593H4.47395L4.47382 1.74004ZM1.73995 14.7256H22.8245V17.1176H1.73995V14.7256Z"
      fill="#09507C"
    />
  </svg>
);
